import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import * as Icon from '../Icon';
import { Texts } from '../../constants';
import useStyles from './styles';

interface WidgetButtonProps {
  btnRef: React.RefObject<HTMLButtonElement>
  isDragging: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  onPointerDown: React.PointerEventHandler<HTMLButtonElement>
  onPointerMove: React.PointerEventHandler<HTMLButtonElement>
  onPointerUp: React.PointerEventHandler<HTMLButtonElement>
  onLostPointerCapture: React.PointerEventHandler<HTMLButtonElement>
}

const WidgetButton: React.FC<WidgetButtonProps> = (props) => {
  const { onClick, btnRef, isDragging, onPointerDown, onPointerMove, onPointerUp, onLostPointerCapture } = props;
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={Texts.dialogTitle}
      open={isDragging ? false : undefined}
    >
      <IconButton
        ref={btnRef}
        onClick={onClick}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onLostPointerCapture={onLostPointerCapture}
        data-cy="widget-button"
        size="medium"
        className={`${classes.button}${isDragging ? ` ${classes.dragging}` : ''}`}
      >
        <Icon.Stars />
      </IconButton>
    </Tooltip>
  );
};

export default WidgetButton;
